import moment from 'moment'

import {
  emailState,
  screenNameState,
  joinedState,
  lastState,
  projectState,
} from 'components/Participants/Filters/FilterState'

type FilterType = {
  condition: string
  field_name?: string
  sequence?: number
  value: string
  fieldName: string
}

const handleStatusFilter = (
  filter: FilterType,
  allFilters: FilterType[],
  sorted: FilterType[],
) => {
  // There are two filters associated with status field name i.e status and import
  if (filter.value === 'imported') {
    const importedFilter = allFilters.find(
      (f: FilterType) => f.fieldName === 'status' && f.value === 'imported',
    )
    if (importedFilter)
      sorted.push(...getFirstUniqueFilterObjects([importedFilter]))
  } else {
    const values = ['active', 'blocked', 'pending_activation']
    const statusFilter = allFilters.find(
      (f: FilterType) =>
        f.fieldName === 'status' && values.indexOf(f.value) > -1,
    )

    if (statusFilter)
      sorted.push(...getFirstUniqueFilterObjects([statusFilter]))
  }
}

export const sortFiltersWithInitialState = (filters: FilterType[]) => {
  const sorted = []
  const uniqueField = new Set()
  const singleFilters = ['hubs', 'suburb', 'participant_tag', 'project_tag']
  for (let i = 0; i < filters.length; i++) {
    const filter = filters[i]

    if (!uniqueField.has(filter.fieldName)) {
      if (filter.fieldName === 'status') {
        handleStatusFilter(filter, filters, sorted)
      } else if (singleFilters.indexOf(filter.fieldName) > -1) {
        // We don't need uniqueness check here as these filters will appear the way they are added
        sorted.push(filter)
      } else {
        // For email, screen name ... more to be added
        uniqueField.add(filter.fieldName)
        const all = filters.filter(
          (f: FilterType) => filter.fieldName === f.fieldName,
        )

        const uniqueFiltersFromField = getFirstUniqueFilterObjects(all)

        // Sorting is needed to show the filter based on UI sequence
        const sortedUniqueFiltersFromField = uniqueFiltersFromField.sort(
          (a, b) => {
            if (a.sequence && b.sequence) {
              return a.sequence - b.sequence
            }
            return 0
          },
        )
        sorted.push(...sortedUniqueFiltersFromField)
      }
    }
  }

  return sorted
}

export const getFirstUniqueFilterObjects = (
  filters: FilterType[],
): FilterType[] => {
  if (filters.length === 1) return filters

  const uniqField = new Set()

  const result = []

  for (let i = 0; i < filters.length; i++) {
    const element = filters[i]
    const key = `${element.fieldName}${element.condition}`

    if (!uniqField.has(key)) {
      result.push(element)
      uniqField.add(key)
    }
  }

  return result
}

export const mergeInitialStateWithFilters = (
  uniqueFieldName: any,
  filters: any,
) => {
  const fieldNames = Array.from(uniqueFieldName)
  const newFilters = [...filters]

  fieldNames.forEach((fieldName) => {
    switch (fieldName) {
      case 'email':
        newFilters.push(...emailState)

        break

      case 'login':
        newFilters.push(...screenNameState)

        break

      case 'joined':
        newFilters.push(...joinedState)

        break

      case 'last_visited':
        newFilters.push(...lastState)

        break

      case 'project_activity':
        newFilters.push(...projectState)

        break

      default:
        break
    }
  })

  return newFilters
}

const reduceFormattedArrayForDateQuestion = (
  selectedAndFormattedArray: IndexType[],
) => {
  /**
   * To merge the following array objects because the question will have both befor 
   * and after attached or either one of them
   * [
    {
        "name": "",
        "before": "2022-12-30T18:30:00.000Z"
    },
    {
        "name": "",
        "after": "2017-12-31T18:30:00.000Z"
    }
]
   */
  const reducedArray = selectedAndFormattedArray.reduce(function (
    acc: { [x: string]: any },
    x: { [x: string]: any },
  ) {
    for (const key in x) acc[key] = x[key]
    return acc
  },
  {})

  return reducedArray
}

const getDefaultFormattedDate = (item: IndexType) => {
  return (
    item.value &&
    moment(moment(item.value[0][item.selected]).toDate(), 'MM/DD/YYYY')
  )
}

export const getFormattedDateQuestionValues = (
  matchedValueDateQuestions: string | any[],
) => {
  let formattedValue: IndexType

  const selectedAndFormattedArray: Array<IndexType> = []

  for (let index = 0; index < matchedValueDateQuestions.length; index++) {
    const item = matchedValueDateQuestions[index]

    if (item.type === 'DateQuestion') {
      formattedValue = {
        name: '',
        [item.selected]: getDefaultFormattedDate(item),
      }
      selectedAndFormattedArray.push({ ...formattedValue })
    }
  }

  return reduceFormattedArrayForDateQuestion(selectedAndFormattedArray)
}
